export * from './terminal';

export type Currency = {
  label: string;
  logo: string;
  l1: string;
  l2: string;
  chains: string[];
  decimals: number;
  l1Bridge?: string;
  l2Bridge?: string;
};

export interface NetworkOption {
  label: string;
  logo: string;
}

export const networkOptions: NetworkOption[] = [
  {
    label: 'Ethereum',
    logo: '/assets/icons/eth_blue.svg',
  },
];

export const AmountInputColorTheme = {
  red: {
    border: 'border-[#F12150]',
    text: 'text-[#F12150]',
    background: 'bg-neutral-900',
  },
  orange: {
    border: 'border-orange-500',
    text: 'text-neutral-100',
    background: 'bg-neutral-900',
  },
};
